import React from "react";
import ServiceSection from "../components/Service";
import Footer from "../components/Footer";
import "../css/style.css";
import ServiceIntro from "../components/ServiceIntro";
function Services() {
  return (
    <div className="Service-section">
        
    <ServiceIntro />
    <ServiceSection />
    <Footer />
    </div>
    
    
  );
}

export default Services;
